import React from 'react';
import { Link } from 'react-router-dom';

const RealEstate = () => {
    const services = [
        {
            icon: '📊',
            title: 'Investment Analysis',
            description: 'Comprehensive property analysis and ROI projections to identify profitable opportunities.'
        },
        {
            icon: '🏠',
            title: 'Property Sourcing',
            description: 'Access to off-market deals and investment-grade properties across multiple markets.'
        },
        {
            icon: '📈',
            title: 'Market Research',
            description: 'In-depth market analysis and trend forecasting to guide investment decisions.'
        },
        {
            icon: '💼',
            title: 'Portfolio Strategy',
            description: 'Customized investment strategies to build and diversify your real estate portfolio.'
        },
        {
            icon: '🔧',
            title: 'Property Management',
            description: 'End-to-end property management consulting for hassle-free ownership.'
        },
        {
            icon: '🤝',
            title: 'Deal Structuring',
            description: 'Creative financing solutions and partnership structures for optimal returns.'
        }
    ];

    const propertyTypes = [
        { icon: '🏢', name: 'Commercial' },
        { icon: '🏠', name: 'Residential' },
        { icon: '🏭', name: 'Industrial' },
        { icon: '🏪', name: 'Retail' },
        { icon: '🏨', name: 'Multi-Family' },
        { icon: '🌳', name: 'Land' }
    ];

    return (
        <div className="page">
            {/* Hero Section — side fade, property image right */}
            <section
                className="page-hero-side-fade"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/luxury-home.jpg)`, backgroundPosition: 'center' }}
            >
                <div className="container">
                    <div className="hero-side-content">
                        <h1>Real Estate <span className="text-gradient">Investment</span></h1>
                        <p>
                            Strategic real estate investment consulting to help you build wealth
                            through property ownership and passive income.
                        </p>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Our <span className="text-gradient">Services</span></h2>
                        <p>Comprehensive real estate investment consulting</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="card card-gradient service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Feature row — consulting image */}
            <div className="image-feature-row">
                <div
                    className="feature-img"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/property-data.jpg)` }}
                />
                <div className="feature-body">
                    <h3>Data-Driven <span className="text-gradient">Investment Decisions</span></h3>
                    <p>We analyze market conditions, property values, and return projections so you invest with confidence — not guesswork.</p>
                </div>
            </div>

            {/* Property Types Section */}
            <section className="section bg-dark">
                <div className="container">
                    <div className="section-header">
                        <h2>Property <span className="text-gradient">Types</span></h2>
                        <p>Expertise across all major real estate asset classes</p>
                    </div>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                        gap: '1rem'
                    }}>
                        {propertyTypes.map((type, index) => (
                            <div
                                key={index}
                                className="card"
                                style={{ textAlign: 'center', padding: '1.5rem' }}
                            >
                                <span style={{ fontSize: '2.5rem' }}>{type.icon}</span>
                                <h4 style={{ marginTop: '0.5rem' }}>{type.name}</h4>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Real Estate Section */}
            <section className="section">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Invest in <span className="text-gradient">Real Estate</span>?</h2>
                        <p>The proven path to building lasting wealth</p>
                    </div>
                    <div className="features-grid">
                        <div className="feature-item">
                            <div className="feature-icon">💰</div>
                            <div className="feature-content">
                                <h4>Passive Income</h4>
                                <p>Generate consistent cash flow through rental income</p>
                            </div>
                        </div>
                        <div className="feature-item">
                            <div className="feature-icon">📈</div>
                            <div className="feature-content">
                                <h4>Appreciation</h4>
                                <p>Build equity as property values increase over time</p>
                            </div>
                        </div>
                        <div className="feature-item">
                            <div className="feature-icon">🏦</div>
                            <div className="feature-content">
                                <h4>Tax Benefits</h4>
                                <p>Take advantage of depreciation and other tax advantages</p>
                            </div>
                        </div>
                        <div className="feature-item">
                            <div className="feature-icon">🛡️</div>
                            <div className="feature-content">
                                <h4>Inflation Hedge</h4>
                                <p>Protect your wealth against inflation with tangible assets</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="section">
                <div className="container">
                    <div className="cta-section">
                        <div className="cta-content">
                            <h2>Ready to Invest in Real Estate?</h2>
                            <p>
                                Schedule a consultation to discuss your investment goals and opportunities.
                            </p>
                            <Link to="/contact" className="btn btn-primary">
                                Book Consultation →
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RealEstate;